"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calcNodeNeedsPaging_1 = __importDefault(require("@opsbase/lib-data-element/helpers/calcNodeNeedsPaging"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useNewDataActions_1 = __importDefault(require("@opsbase/web-ctrl-newdata/useNewDataActions"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const DVLController_1 = __importDefault(require("@opsbase/web-dvl/DVLController"));
const DVLEmpty_1 = __importDefault(require("@opsbase/web-dvl/DVLEmpty"));
const DVLSectionTree_1 = __importDefault(require("@opsbase/web-dvl/DVLSectionTree/DVLSectionTree"));
const Card_1 = __importDefault(require("@opsbase/web-layout/Card"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const react_1 = __importStar(require("react"));
const DVLTableGroup_1 = __importDefault(require("../DVLTableGroup"));
const DVLTableHeader_1 = __importDefault(require("../DVLTableHeader"));
const DVLTableItem_1 = __importDefault(require("../DVLTableItem"));
const DVLTableRowPager_1 = __importDefault(require("../DVLTableRow/DVLTableRowPager"));
const makeMyClasses = (isEmpty) => ({
    dots: {
        margin: '32px auto',
    },
    root: {
        border: isEmpty ? 0 : undefined,
        backgroundColor: isEmpty ? 'transparent' : undefined,
        height: 'auto',
        overflow: 'auto',
        minHeight: 0,
        maxHeight: '100%',
        position: 'relative',
        opacity: 1,
        transition: 'opacity 0.5s',
    },
    vertical: {
        minWidth: 'fit-content',
        minHeight: 'fit-content',
    },
    headerPane: {
        backgroundColor: 'white',
        position: 'sticky',
        top: 0,
        zIndex: 101,
    },
    paging: {
        backgroundColor: 'white',
        position: 'sticky',
        left: 0,
        bottom: 0,
        zIndex: 99,
        borderTop: `1px solid ${lib_palette_1.default.LineGrey.main}`,
    },
    mainPane: {},
    justAddedPane: {
        backgroundColor: lib_palette_1.default.NoteYellow.main,
        '& .rowHeader': {
            background: 'transparent !important',
        },
        '& .treeLines': {
            visibility: 'hidden !important',
        },
    },
});
function DVLTable(props) {
    var _a, _b, _c;
    const { classes, disableHeadings = false, itemComponent = DVLTableItem_1.default, groupComponent = DVLTableGroup_1.default } = props, otherProps = __rest(props, ["classes", "disableHeadings", "itemComponent", "groupComponent"]);
    const dt = (0, useDataTree_1.default)();
    const { getItemsForType } = (0, useNewDataActions_1.default)();
    const { groupBys } = (0, useView_1.default)(dt.viewId);
    const [initialised, setInitialised] = (0, react_1.useState)(false);
    const nodeKey = (_a = dt.rootNode) === null || _a === void 0 ? void 0 : _a.nodeKey;
    const isLoading = (_b = dt.dataStatus) === null || _b === void 0 ? void 0 : _b.loading;
    const isGrouping = !!groupBys.length;
    const isEmpty = !isGrouping && !isLoading && ((_c = dt.totalCountForNode) === null || _c === void 0 ? void 0 : _c.get(dt.rootNode)) === 0;
    const needsPaging = (0, calcNodeNeedsPaging_1.default)(dt.rootNode);
    const myCss = (0, web_css_1.default)(makeMyClasses, [isEmpty], classes);
    (0, react_1.useEffect)(() => {
        if (!initialised)
            setInitialised(initialised || !isLoading);
    }, [isLoading, initialised]);
    const justAddedItems = getItemsForType(dt.viewId);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(DVLController_1.default, Object.assign({}, otherProps),
        react_1.default.createElement(Card_1.default, { classes: { root: myCss.root } },
            react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.vertical } },
                // LOADER
                !initialised && (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true },
                    react_1.default.createElement(Dots_1.default, { className: myCss.dots, color: lib_palette_1.default.LavendarGrey }))),
                // EMPTY MESSAGE
                initialised && isEmpty && react_1.default.createElement(DVLEmpty_1.default, null),
                // DATA LIST - Header
                initialised && !isEmpty && !disableHeadings && (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true, classes: { root: myCss.headerPane } },
                    react_1.default.createElement(DVLTableHeader_1.default, null))),
                // DATA LIST - Body
                (justAddedItems === null || justAddedItems === void 0 ? void 0 : justAddedItems.length) ? (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true, classes: { root: myCss.justAddedPane } }, justAddedItems === null || justAddedItems === void 0 ? void 0 : justAddedItems.map((item, i) => (react_1.default.createElement(DVLTableItem_1.default, { key: 'added' + i, item: item, isLast: false, rowIdx: i, nodeKey: nodeKey }))))) : null,
                // DATA LIST - Body
                initialised && !isEmpty && (react_1.default.createElement(Pane_1.default, { shrink: true, visible: true, classes: { root: myCss.mainPane } },
                    react_1.default.createElement(DVLSectionTree_1.default, { nodeKey: nodeKey, itemComponent: itemComponent, groupComponent: groupComponent })))),
            !!needsPaging && (react_1.default.createElement(Horizontal_1.default, { padding: true, classes: { root: myCss.paging } },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(DVLTableRowPager_1.default, { oneLine: true, nodeKey: nodeKey }),
                react_1.default.createElement(Pane_1.default, { grow: true })))))), [
        otherProps,
        myCss,
        initialised,
        isEmpty,
        disableHeadings,
        justAddedItems,
        nodeKey,
        itemComponent,
        groupComponent,
        needsPaging,
    ]);
}
exports.default = DVLTable;
